import { axiosInstance, put, get, post } from "@/vue/api/api";
import axios from "axios";

export const autoattendant = {
  state: {
    autoAttendants: [],
    branches: [],
    extensions: [],
    aaInfo: [],
    dids: [],
    locale: {},
  },
  getters: {
    getAutoAttendants: (state) => {
      return state.autoAttendants;
    },
    getBranches: (state) => {
      return state.branches;
    },
    getExtensionNumbers: (state) => {
      return state.extensions;
    },
    getAaInfo: (state) => {
      return state.aaInfo;
    },
    getDids: (state) => {
      return state.dids;
    },
    getLocale: (state) => {
      return state.locale;
    },
  },
  mutations: {
    SET_AUTO_ATTENDANTS: (state, payload) => {
      state.autoAttendants = payload;
    },
    SET_BRANCHES: (state, payload) => {
      state.branches = payload;
    },
    SET_EXTENSION_NUMBERS: (state, payload) => {
      state.extensions = payload;
    },
    SET_AA_INFO: (state, payload) => {
      state.aaInfo = payload;
    },
    SET_DIDS: (state, payload) => {
      state.dids = payload;
    },
    SET_LOCALE: (state, payload) => {
      state.locale = payload;
    },
  },
  actions: {
    fetchAutoAttendants: ({ commit, rootGetters }, payload) => {
      get("/v1/pbxes/" + rootGetters.getCustomer.pbx.id + "/auto_attendant")
        .then((response) => {
          console.log("fetchAutoAttendants response");
          console.log(response);

          commit("SET_AUTO_ATTENDANTS", response.data);
          if (payload.success) {
            payload.success("Retrieved auto attendants");
          }
        })
        .catch((error) => {
          console.log("fetchAutoAttendants error");
          console.log(error.message);
          if (payload.error) {
            payload.error(error.message);
          }
        });
    },
    createAutoAttendants: ({ commit, dispatch, rootGetters }, payload) => {
      post(
        "/v1/pbxes/" + rootGetters.getCustomer.pbx.id + "/auto_attendant",
        payload.data
      )
        .then((response) => {
          console.log("createAutoAttendants response");
          console.log(response);

          payload.success(response);
          //audit
          dispatch("sendAudit", {
            eventType: "CREATE",
            objectType: "Auto Attendant",
            details: payload.data,
          });
        })
        .catch((error) => {
          console.log("createAutoAttendants error");
          console.log(error.message);
          if (payload.error) {
            payload.error(error.message);
          }
        });
    },
    updateAutoAttendants: ({ commit, dispatch, rootGetters }, payload) => {
      put(
        "/v1/pbxes/" + rootGetters.getCustomer.pbx.id + "/auto_attendant",
        payload.data
      )
        .then((response) => {
          console.log("updateAutoAttendants response");
          console.log(response);

          payload.success(response);
          //audit
          dispatch("sendAudit", {
            eventType: "UPDATE",
            objectType: "Auto Attendant",
            details: payload.data,
          });
        })
        .catch((error) => {
          console.log("updateAutoAttendants error");
          console.log(error.message);
          if (payload.error) {
            payload.error(error.message);
          }
        });
    },
    async fetchDids({ commit }) {
      const response = await axiosInstance.get("/v1/dms/dids");
      const dids = response.data.data;
      commit("SET_DIDS", dids);
      return dids;
    },
    fetchValidationRules: ({ commit, rootGetters, dispatch }, payload) => {
      const branches = axiosInstance.get(
        "/v1/pbxes/" + rootGetters.getCustomer.pbx.id + "/sites/id_and_name"
      );
      const extensions = axiosInstance.get(
        "/v1/pbxes/" + rootGetters.getCustomer.pbx.id + "/extensions/numbers"
      );
      const aaInfo = axiosInstance.get("/v1/auto_attendant/info");
      const dids = dispatch("fetchDids");
      const locale = axiosInstance.get("/v1/vo/supported_values");

      axios
        .all([branches, extensions, aaInfo, dids, locale])
        .then(
          axios.spread((...response) => {
            console.log("response spread:");
            console.log(response);

            if (response[0]) {
              commit("SET_BRANCHES", response[0].data.data);
            }
            if (response[1]) {
              commit("SET_EXTENSION_NUMBERS", response[1].data.data);
            }
            if (response[2]) {
              commit("SET_AA_INFO", response[2].data.data);
            }
            if (response[4]) {
              commit("SET_LOCALE", response[4].data.data);
            }

            payload.success("Retrieved validation rules");
          })
        )
        .catch((error) => {
          console.log("error sprad");
          console.log(error.message);
          if (payload.error) {
            payload.error(error.message);
          }
        });
    },
    fetchLocales: ({ commit }, payload) => {
      get("/v1/vo/supported_values")
        .then((response) => {
          console.log("fetchLocales response");
          console.log(response);

          commit("SET_LOCALE", response.data);
          payload.success("Retrieved locales");
        })
        .catch((error) => {
          console.log("fetchLocales error");
          console.log(error.message);

          if (payload.error) {
            payload.error(error.message);
          }
        });
    },
  },
};
